import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, Switch, Button, Avatar } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import apiRequest from "apiRequest";

function CustomersTable({ rows, onToggleStatus, detailClick }) {
  const data = Array.isArray(rows) ? rows : [];

  return (
    <TableContainer component={Paper} style={{ marginTop: 4 }}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Email</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Phone</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Joined</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Total Orders</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
          </TableRow>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No customers found
              </TableCell>
            </TableRow>
          ) : (
            data.map((customer) => {
              const customerId = customer.id ?? customer._id;
              const joinedAt = customer.createdAt || customer.created_at || customer.joinedAt;
              const totalOrders = customer.total_orders ?? customer.orders_count ?? customer.ordersTotal ?? 0;
              const avatarSource = customer?.profile ? `${apiRequest.BASE_URL}/${customer.profile}` : undefined;

              return (
                <TableRow key={customerId} hover>
                  <TableCell>
                    <MDBox display="flex" alignItems="center">
                      <Avatar src={avatarSource} sx={{ width: 36, height: 36, mr: 1 }} />
                      <MDTypography variant="button" fontWeight="medium">
                        {customer?.full_name || customer?.name || "-"}
                      </MDTypography>
                    </MDBox>
                  </TableCell>
                  <TableCell>{customer.email || "-"}</TableCell>
                  <TableCell>{customer.contact || customer.phone || "-"}</TableCell>
                  <TableCell>{joinedAt ? new Date(joinedAt).toLocaleString() : ""}</TableCell>
                  <TableCell>{totalOrders}</TableCell>
                  <TableCell>
                    <Switch
                      checked={customer.status === "active"}
                      onChange={() => onToggleStatus(customerId)}
                      color="primary"
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      onClick={() => customerId && detailClick(customerId)}
                      size="small"
                      disabled={!customerId}
                    >
                      Detail
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CustomersTable;
